// extracted by mini-css-extract-plugin
module.exports = {"icon":"citation-input-search-result-single_icon__fTrDW","row":"citation-input-search-result-single_row__4isaL"};